import * as React from "react";
import { WinningsDataModel, PriceStatusClass } from "../../data/models";
import { observer } from "mobx-react";

const baseClass = "rj-winnings";
@observer
export class Winnings extends React.Component<{
    inputData: WinningsDataModel
    onStakeChangeFading: boolean
}, {}> {
    renderCurrent(data) {
        let fadingClass = this.props.onStakeChangeFading ? ` ${baseClass}__item--fading-winnings` : "";

        return (
            <div key={`${baseClass}-${data.periodNumber}`} className={`${baseClass}__item${` ${baseClass}__item--${PriceStatusClass.periodCurrent}`}${fadingClass}`} data-atr={data.status}>
                <div className={`${baseClass}__item-inner`}>
                    <span className={`${baseClass}__sum`}>
                        {data.winningValue}
                    </span>
                </div>
            </div>
        );
    }
    renderWithoutClass(data) {
        let fadingClass = this.props.onStakeChangeFading ? ` ${baseClass}__item--fading-winnings` : "";

        return (
            <div key={`${baseClass}-${data.periodNumber}`} className={`${baseClass}__item${fadingClass}`} data-atr={data.status}>
                <div className={`${baseClass}__item-inner`}>
                    <span className={`${baseClass}__sum`}>
                        {data.winningValue}
                    </span>
                </div>
            </div>
        );
    }
    renderResulting(data) {
        let fadingClass = this.props.onStakeChangeFading ? ` ${baseClass}__item--fading-winnings` : "";

        return (
            <div key={`${baseClass}-${data.periodNumber}`} className={`${baseClass}__item${` ${baseClass}__item--${PriceStatusClass.periodResulting}`}${fadingClass}`} data-atr={data.status}>
                <div className={`${baseClass}__item-inner`}>
                    <span className={`${baseClass}__sum`}>
                        {data.winningValue}
                    </span>
                </div>
            </div>
        );
    }
    renderPreperiod(data) {
        let fadingClass = this.props.onStakeChangeFading ? ` ${baseClass}__item--fading-winnings` : "";

        return (
            <div key={`${baseClass}-${data.periodNumber}`} className={`${baseClass}__item${` ${baseClass}__item--${PriceStatusClass.periodPre}`}${fadingClass}`} data-atr={data.status}>
                <div className={`${baseClass}__item-inner`}>
                    <span className={`${baseClass}__sum`}>
                        {data.winningValue}
                    </span>
                </div>
            </div>
        );
    }

    renderPeriodOver(data) {
        let fadingClass = this.props.onStakeChangeFading ? ` ${baseClass}__item--fading-winnings` : "";

        return (
            <div key={`${baseClass}-${data.periodNumber}`} className={`${baseClass}__item${` ${baseClass}__item--${PriceStatusClass.periodOver}`}${fadingClass}`} data-atr={data.status}>
                <div className={`${baseClass}__item-inner`}>
                    <span className={`${baseClass}__sum`}>
                        {data.winningValue}
                    </span>
                </div>
            </div>
        );
    }
    renderWinning(status) {
        switch (status.winningStatus) {
            case 0:
                return this.renderPreperiod(status);
            case 1:
            return this.renderCurrent(status);
            case 2:
                return this.renderResulting(status);
            case 3:
            return this.renderPeriodOver(status);
        }
        return this.renderWithoutClass(status);
    }

    render() {
        return (
            <div className={`${baseClass}__items-holder`}>
                {this.props.inputData.winnings.map(
                    this.renderWinning, this
                )}
            </div>
        )
    }
}